import React, { useState } from "react";
import { Form } from "react-bootstrap";
import MainPageModal from "components/modal/MainPageModal";
import { BasicAlert } from "components/Alert";
import firebase from "firebase/app";
import "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.FIREBASE_CONFIG_API_KEY,
  authDomain: process.env.FIREBASE_CONFIG_AUTH_DOMAIN,
  projectId: process.env.FIREBASE_CONFIG_PROJECT_ID,
  storageBucket: process.env.FIREBASE_CONFIG_STORAGE_BUCKET,
  messagingSenderId: process.env.FIREBASE_CONFIG_MESSAGING_SENDER_ID,
  appId: process.env.FIREBASE_CONFIG_APP_ID,
  measurementId: process.env.FIREBASE_CONFIG_MEASUREMENT_ID,
};

if (firebase.apps.length === 0) {
  firebase.initializeApp(firebaseConfig);
}

const auth = firebase.auth();

const ForgotPassword = () => {
  // email, password 값 저장
  const [email, setEmail] = useState();
  const [modalVisible, setModalVisible] = useState(false);

  const sendButtonClick = async () => {
    if (!email) {
      BasicAlert("이메일을 입력해주세요.");
      return;
    }

    try {
      const value = await auth.fetchSignInMethodsForEmail(email);
      console.log("value :", value);
      if (value.length === 0) {
        BasicAlert("등록된 메일이 없습니다.");
        return;
      } else {
        await auth
          .sendPasswordResetEmail(email)
          .then(() => console.log("메일이 정상적으로 전송되었습니다."))
          .catch((error) => {
            console.log("메일 전송 오류 :", error);
          });
        setModalVisible(true);
      }
    } catch (error) {
      console.log("error :", error);
      if (error.code === "auth/invalid-email") {
        BasicAlert("이메일 주소 형식이 잘못되었습니다.");
        return;
      } else {
        BasicAlert(error.message);
        return;
      }
    }
  };

  return (
    <div className="flex items-center auth pt-5 pb-20 login-bg">
      <div className="row w-100 mx-0 h-full">
        <div className="col-12 col-md-8 col-xl-4 mx-auto">
          <div className="text-left py-5 px-4 px-sm-5">
            <h1 className="text-center mb-5 sign-font">Forgot Password</h1>
            <h4 className="text-blue-500">Forgot Your Password</h4>
            <h5 className="text-888">Please enter your email</h5>
            <Form className="pt-4">
              <Form.Group className="d-flex search-field bg-white shadow-md">
                <Form.Control
                  type="email"
                  placeholder="Email"
                  size="lg"
                  className="h-auto"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Group>
              <div className="mt-4 shadow-md">
                <button type="button" className="btn btn-block btn-primary auth-form-btn" onClick={() => sendButtonClick()}>
                  SEND
                </button>
              </div>
              <div className="text-center mt-4 font-weight-light">
                {/* Don't have an account? */}
                {/* <Link href="/signup">
                  <a className="font-medium text-blue-500 ml-2">Login</a>
                </Link> */}
              </div>
            </Form>
          </div>
          <div className="center">
            <img src="/images/header/img-logo-full@3x.png" alt="logo" className="w-2/12" />
          </div>
        </div>
      </div>
      <MainPageModal modalVisible={modalVisible} closeModal={() => setModalVisible(false)} />
    </div>
  );
};

export default ForgotPassword;
